import handsIcon from './assets/hands.png';
import houseIcon from './assets/house.png';
import laptopIcon from './assets/laptop.png';
import { NBSP, LF } from '../../constants/symbols';

export const USP_DATA = [
  {
    title: `До${NBSP}3${NBSP}000${NBSP}000${NBSP}₽ за${NBSP}сделку`,
    image: handsIcon,
    hasTooltip: true,
  },
  {
    title: `Всё${NBSP}для${NBSP}сделки${NBSP}— ${LF}в${NBSP}одном личном кабинете`,
    image: laptopIcon,
    hasTooltip: false,
  },
  {
    title: `Деньги на${NBSP}карте${NBSP}— ${LF}за${NBSP}2-3${NBSP}дня`,
    image: houseIcon,
    hasTooltip: false,
  },
] as const;

export const TYPOGRAPHY = {
  SECTION_TITLE: 'Начните зарабатывать прямо сейчас',
  TOOLTIP_TEXT: `Примерные суммы вознаграждения с учётом средних цен сделок в Москве: ${LF}${LF}~ 3 000 000 ₽ за премиум-класс  ${LF}~ 1 000 000 ₽ за бизнес-класс  ${LF}~ 700 000 ₽ за комфорт-класс ${LF}${LF}Точная сумма зависит от цены сделки.`,
};
